import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormFolder } from 'src/app/core/models/physician/form-folder';
import { PdfForm } from 'src/app/core/models/physician/pdfform';
import { FormbaseService, FormService } from 'src/app/core/services/v2/form.service';

@Component({
  selector: 'app-add-pdfform',
  templateUrl: './add-pdfform.component.html',
  styleUrls: ['./add-pdfform.component.scss']
})
export class AddPdfformComponent implements OnInit {
pdfFormModel:PdfForm=new PdfForm();
formFolders:FormFolder[]=[];
  constructor(  public dialogRef: MatDialogRef<AddPdfformComponent>,
    private formService: FormService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      dialogRef.disableClose = true;
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.getAllFormFolders() ;
  }

  getAllFormFolders() {     
    this.formService.getFormsGroups().subscribe(
          (list) => {
            this.formFolders = list.result;
            //this.checkForSelectedFolders();
          },
          (error) => { console.error(error); }
        )
   
  }
  pdfInputChange(fileInputEvent: any) {
    this.pdfFormModel.file=fileInputEvent.target.files[0];
  }
  onSave(pdfFormModel:PdfForm){
    if(pdfFormModel.file)
    this.formService.addPdfForm(pdfFormModel).subscribe(
      (r) => {
        this.dialogRef.close();
        //this.checkForSelectedFolders();
      },
      (error) => { console.error(error); }
    )
    
    console.log(pdfFormModel)
  }

}
